var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-autocomplete',{staticClass:"categories-options",attrs:{"hide-details":"","disabled":_vm.disabledPatient,"rounded":true,"placeholder":"Nome do paciente","dense":"","height":"30","items":_vm.patients.map(function (ref) {
	var name = ref.name;

	return name;
}),"return-object":""},on:{"change":_vm.setItem},model:{value:(_vm.finalItem),callback:function ($$v) {_vm.finalItem=$$v},expression:"finalItem"}})}
var staticRenderFns = []

export { render, staticRenderFns }